import { OptionType } from "@/types/OptionType";
import { ComponentPublicInstance } from "@vue/runtime-core";

export const translateLabels = (component: ComponentPublicInstance, options: OptionType[]): OptionType[] =>
  options.map((option) => ({
    ...option,
    label: component.$te(option.label) ? component.$t(option.label) : option.label,
  }));
